import React, { useState, useEffect } from "react";
import Topbar from "../../components/topbar/Topbar";

// Redux stuff
import { connect } from "react-redux";
import {
  profileImageUpload,
  coverImageUpload,
} from "../../redux/actions/providerActions";

//Styles
import styles from "./settings.module.css";

//Material ui icons
import CreateIcon from "@material-ui/icons/Create";

//Material ui components
import { withStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Chip from "@material-ui/core/Chip";
import Input from "@material-ui/core/Input";

const useStyles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
    background: "linear-gradient(180deg, #6989FE 0%, #3C64F4 100%)",
    color: "white",
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
});

const Settings = (props) => {
  const { classes } = props;

  const [data, setData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    enrollmentNo: "",
    batch: "",
    branch: "",
    phoneNo: "",
    interest: "",
    gender: "",
    userId: "",
    profileImage: "",
    coverImage: "",
  });

  const [skills, setSkills] = useState([]);

  useEffect(() => {
    setData((prevState) => ({
      ...prevState,
      email: props.provider.userData.email,
      firstName: props.provider.userData.firstName,
      lastName: props.provider.userData.lastName,
      enrollmentNo: props.provider.userData.enrollmentNo,
      batch: props.provider.userData.batch,
      branch: props.provider.userData.branch,
      phoneNo: props.provider.userData.phoneNo,
      userId: props.provider.userData._id,
      gender: props.provider.userData.gender
        ? props.provider.userData.gender
        : "",
      interest: props.provider.userData.interest
        ? props.provider.userData.interest
        : "",
      profileImage: props.provider.userData.profileImage
        ? props.provider.userData.profileImage
        : "https://res.cloudinary.com/one-click/image/upload/v1627224410/ProfileImage/defaultProfileImage_ev0jsj.png",
      coverImage: props.provider.userData.coverImage
        ? props.provider.userData.coverImage
        : "https://res.cloudinary.com/one-click/image/upload/v1627218488/ProfileCoverImage/defaultCover_h8mmcz.jpg",
    }));

    if (props.provider.userData.skills)
      setSkills(props.provider.userData.skills);
    else setSkills([]);
  }, [props.provider.userData, props.provider.userData.gender]);

  const {
    email,
    firstName,
    lastName,
    enrollmentNo,
    batch,
    branch,
    interest,
    phoneNo,
    gender,
    profileImage,
    coverImage,
  } = data;

  const names = [
    "Digital Marketing",
    "Buisness Analytics",
    "Marketing",
    "Designing",
    "Graphic Designing",
    "Web Development",
    "React",
    "MERN Stack",
    "UI/UX Desgning",
    "Front End",
    "Data Analytics",
    "Machine Learning",
    "Artificial Intelligence",
    "Audio Analyst",
    "Adobe Photoshop",
    "Account Management",
  ];

  const onInputChange = (e) => {
    setData((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    console.log(data, skills);
  };

  const handleChange = (event) => {
    setSkills(event.target.value);
    console.log(event.target.value);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const handleProfileImageEdit = () => {
    const fileInput = document.getElementById("profileImage");
    fileInput.click();
  };

  const handleProfileImageChange = (event) => {
    const image = event.target.files[0];
    const formData = new FormData();
    formData.append("file", image, image.name);
    props.profileImageUpload(formData, props.provider.userData._id);
  };

  const handleCoverImageEdit = () => {
    const fileInput = document.getElementById("coverImage");
    fileInput.click();
  };

  const handleCoverImageChange = (event) => {
    const image = event.target.files[0];
    const formData = new FormData();
    formData.append("file", image, image.name);
    props.coverImageUpload(formData, props.provider.userData._id);
  };

  return (
    <>
      <Topbar
        name={"Profile Settings 👀"}
        buttonText={"Save"}
        data={{ ...data, skills }}
        history={props.history}
        location={props.location}
        match={props.match}
      />
      <div className={styles.mainContainer}>
        <div className={styles.left}>
          <div className={styles.formGroup}>
            <label forhtml="" className={styles.heading}>
              User Information
            </label>
            <div className={styles.subHeading}>
              Enter the required information below to register. You can change
              it anytime you want.
            </div>
          </div>

          <div className={styles.formGroup}>
            <label forhtml="email" className={styles.heading}>
              Email Address
            </label>
            <div className={styles.inputFieldContainer}>
              <input
                className={`${styles.inputField} ${styles.strict}`}
                type="text"
                name="email"
                value={email}
                disabled
              />
            </div>
          </div>

          <div className={styles.formGroup}>
            <label forhtml="forstName" className={`${styles.heading}`}>
              Full Name
            </label>
            <div className={styles.inputFieldContainer}>
              <input
                className={`${styles.inputField} ${styles.strict}`}
                type="text"
                name="firstName"
                placeholder="First Name"
                value={firstName}
                disabled
              />
              <input
                className={`${styles.inputField} ${styles.strict}`}
                type="text"
                name="lastName"
                value={lastName}
                placeholder="Last Name"
                disabled
              />
            </div>
          </div>

          <div className={styles.formGroup}>
            <label forhtml="enrollmentNo" className={styles.heading}>
              Enrollment No./Roll No.
            </label>
            <div className={styles.inputFieldContainer}>
              <input
                className={`${styles.inputField} ${styles.strict}`}
                type="text"
                name="enrollmentNo"
                value={enrollmentNo}
                placeholder="Enter No"
                disabled
              />
            </div>
          </div>

          <div className={styles.formGroup}>
            <label forhtml="phoneNo" className={styles.heading}>
              Phone No.
            </label>
            <div className={styles.inputFieldContainer}>
              <input
                onChange={(e) => onInputChange(e)}
                className={`${styles.inputField} ${styles.editable}`}
                type="text"
                name="phoneNo"
                value={phoneNo}
                placeholder="Phone No"
              />
            </div>
          </div>

          <div className={styles.formGroup}>
            <label forhtml="branch" className={styles.heading}>
              Branch
            </label>
            <div className={styles.inputFieldContainer}>
              <input
                onChange={(e) => onInputChange(e)}
                className={`${styles.inputField} ${styles.editable}`}
                type="text"
                name="branch"
                value={branch}
                placeholder="CSE"
              />
            </div>
          </div>

          <div className={styles.formGroup}>
            <label forhtml="batch" className={styles.heading}>
              Batch
            </label>
            <div className={styles.inputFieldContainer}>
              <input
                onChange={(e) => onInputChange(e)}
                className={`${styles.inputField} ${styles.editable}`}
                type="text"
                name="batch"
                value={batch}
                placeholder="2023"
              />
            </div>
          </div>

          <div className={styles.formGroup}>
            <label fornhtml="skills" className={styles.heading}>
              Choose the skills
            </label>
            <FormControl style={{ width: "100%" }}>
              <Select
                multiple
                value={skills}
                name="skills"
                onChange={(e) => handleChange(e)}
                input={<Input />}
                className={styles.interestSelector}
                renderValue={(selected) => (
                  <div className={classes.chips}>
                    {selected.map((each, index) => (
                      <Chip key={index} label={each} className={classes.chip} />
                    ))}
                  </div>
                )}
                MenuProps={MenuProps}
              >
                {names.map((name) => (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.formGroup}>
            <label forhtml="" className={styles.heading}>
              Profile Photo
            </label>
            <div className={styles.profileImageContainer}>
              <div>
                <img src={profileImage} alt="userName" />
                <input
                  type="file"
                  id="profileImage"
                  hidden="hidden"
                  onChange={handleProfileImageChange}
                />
                <button
                  title="Edit Image"
                  onClick={handleProfileImageEdit}
                  className={styles.profileImageEditButton}
                >
                  <CreateIcon />
                </button>
              </div>
            </div>
          </div>
          <div className={styles.formGroup}>
            <label forhtml="" className={styles.heading}>
              Cover Photo
            </label>
            <div className={styles.coverImageContainer}>
              <div>
                <img src={coverImage} alt="userCover" />
                <input
                  type="file"
                  id="coverImage"
                  hidden="hidden"
                  onChange={handleCoverImageChange}
                />
                <button
                  title="Edit Image"
                  onClick={handleCoverImageEdit}
                  className={styles.coverImageEditButton}
                >
                  <CreateIcon />
                </button>
              </div>
            </div>
          </div>
          <div className={styles.formGroup}>
            <label forhtml="" className={styles.heading}>
              Choose your main interest
            </label>
            <FormControl className={styles.interestContainer}>
              <Select
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                className={styles.interestSelector}
                onChange={(e) => onInputChange(e)}
                value={interest}
                name="interest"
              >
                <MenuItem className={styles.menu} value={"Management"}>
                  Management
                </MenuItem>
                <MenuItem className={styles.menu} value={"Buisness"}>
                  Buisness
                </MenuItem>
                <MenuItem className={styles.menu} value={"Sales"}>
                  Sales
                </MenuItem>
                <MenuItem className={styles.menu} value={"Marketing"}>
                  Marketing
                </MenuItem>
                <MenuItem className={styles.menu} value={"Communication"}>
                  Communication
                </MenuItem>
                <MenuItem className={styles.menu} value={"HR"}>
                  HR
                </MenuItem>
                <MenuItem
                  className={styles.menu}
                  value={"Software Development"}
                >
                  Software Development
                </MenuItem>
                <MenuItem className={styles.menu} value={"Microsoft Office"}>
                  Microsoft Office
                </MenuItem>
                <MenuItem className={styles.menu} value={"Project Management"}>
                  Project Management
                </MenuItem>
                <MenuItem className={styles.menu} value={"Designing"}>
                  Designing
                </MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className={styles.formGroup}>
            <label forhtml="" className={styles.heading}>
              Select your gender
            </label>
            <FormControl component="fieldset" style={{ width: "100%" }}>
              <RadioGroup
                row
                name="gender"
                value={gender}
                style={{ justifyContent: "space-between" }}
                onChange={(e) => onInputChange(e)}
              >
                <FormControlLabel
                  value="femail"
                  control={<Radio color="primary" />}
                  label="Female"
                />
                <FormControlLabel
                  value="male"
                  control={<Radio color="primary" />}
                  label="Male"
                />
                <FormControlLabel
                  value="nonBinary"
                  control={<Radio color="primary" />}
                  label="Non-Binary"
                />
              </RadioGroup>
            </FormControl>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  provider: state.provider,
});

const Sett = withStyles(useStyles, { withTheme: true })(Settings);

export default connect(mapStateToProps, {
  profileImageUpload,
  coverImageUpload,
})(Sett);
